<div class="">
  <div id="divVisor" *ngIf="innerHtml" [innerHTML]="innerHtml">
  </div>
</div>
